export default __webpack_public_path__ + "static/media/daol-lunch.5fb90a47.jpg";